import React from "react";
import MxFormL3FileViewerFieldV2 from "@rf-l3/form/MxFormL3FileViewerFieldV2";
import { AllowedFileExtensions } from "@rf-l1/file/model/types.model";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import useManagerDocumentsDraft from "@/src-refactor/modules/private/properties/components/property-form/hooks/useManagerDocumentsDraft";
import useManagerDocumentsEdit from "@/src-refactor/modules/private/properties/components/property-form/hooks/useManagerDocumentsEdit";
import { useLocation } from "react-router-dom";

interface MxFormL4DocumentFilePropertyProps {
  name: string;
  label?: string;
  withreacthookform?: 1 | 0;
  typeKey: string; // CDocumentKeys | CValidationDocumentKeys
  accept?: AllowedFileExtensions[];
  maxSize?: number;
  minSize?: number;
  disabled?: boolean;
}

const DEFAULT_ACCEPT: AllowedFileExtensions[] = [".jpeg", ".jpg", ".png", ".pdf"];

const MxFormL4DocumentFileProperty: React.FC<
  MxFormL4DocumentFilePropertyProps
> = props => {
  const { uploadDocumentDraft, deleteDocumentDraft } = useManagerDocumentsDraft();
  const { uploadDocumentEdit, deleteDocumentEdit } = useManagerDocumentsEdit();
  const { pathname } = useLocation();
  const isEdit = /^\/realestates\/(project\/)?editar\/\d+$/.test(pathname);

  const handleUpload = async (data: IFileData) =>
    isEdit
      ? uploadDocumentEdit(data, props.typeKey, props.name)
      : uploadDocumentDraft(data, props.typeKey, props.name);

  const handleDelete = (index: number) => {
    return isEdit
      ? (deleteDocumentEdit(index, props.name, props.typeKey) as any)
      : (deleteDocumentDraft(index, props.name) as any);
  };

  return (
    <MxFormL3FileViewerFieldV2
      withreacthookform={props.withreacthookform}
      name={props.name}
      label={props.label}
      maxSize={props.maxSize}
      minSize={props.minSize}
      accept={props.accept ?? DEFAULT_ACCEPT}
      disabled={props.disabled}
      uploadMethod={handleUpload}
      onDeleteFile={handleDelete}
    />
  );
};

export default MxFormL4DocumentFileProperty;
